import React, {
    useContext,
    useMemo,
    useCallback,
    useRef,
    useEffect,
    useState,
} from 'react'
import CollapsibleContainer from '../CollapsibleContainer'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { ReportingContext } from '../../../../wrappers/ReportingContext'
import GenericTable from './table/GenericTable'
import EmptyTitleHeader from './table/TitleHeader'
import JoinColumns from './joins/JoinColumns'
import ConfirmationModal from '../../../../features/reporting/ConfirmationModal'

const Joins = () => {
    const { watch, setValue } = useFormContext()
    const { deleteJoin, reportConfig, saveReport } =
        useContext(ReportingContext)
    const { fields, append, remove } = useFieldArray({
        name: 'joins', // unique name for your Field Array
    })
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [indexToDelete, setIndexToDelete] = useState(null)

    const joins = watch('joins') || []
    const savedJoins = reportConfig?.joins || []

    const isAddDisabled = useMemo(() => {
        return joins.length > savedJoins.length
    }, [joins, savedJoins])

    const onAdd = useCallback(() => {
        append({
            type: 'INNER',
            table1: '',
            table2: '',
            alias: '',
            filters: '{}',
        })
    }, [append])

    const onDelete = useCallback(
        (index) => {
            // remove(index)
            setShowDeleteModal(true)
            setIndexToDelete(index)
            // setValue('joins', joinsAfterDeletion)
        },
        [setShowDeleteModal, setIndexToDelete]
    )

    const onDeleteConfirm = useCallback(() => {
        if (indexToDelete !== null) {
            const reportConfigsAfterJoinsDeletion = deleteJoin(
                indexToDelete,
                setValue
            )
            setIndexToDelete(null)
            setShowDeleteModal(false)
            const allData = watch({ nest: true })
            saveReport({... allData, ...reportConfigsAfterJoinsDeletion })
        }
        // setIndexToDelete(false)
        // setShowDeleteModal(false)

        // setValue('joins', joinsAfterDeletion)
    }, [remove, deleteJoin, indexToDelete, watch])

    return (
        <CollapsibleContainer title="Joins" expanded={false}>
            <div className="content">
                <div className="box" style={{ maxHeight: `80vh` }}>
                    <GenericTable
                        columns={JoinColumns}
                        fields={fields}
                        tableHeight={'65vh'}
                        tableTile={'JOIN Columns'}
                        viewOnly={false}
                        onAddProps={{
                            onClick: onAdd,
                            text: '+ Join',
                            disabled: isAddDisabled,
                        }}
                        onDelete={onDelete}
                        filterable={false}
                        underRowHeaderName={'Filters'}
                        noDataMessage="No joins added; the report can only include columns from the Primary Source."
                    />
                    <ConfirmationModal
                        display={showDeleteModal}
                        title="Delete Join Confirmation"
                        confirmAction={() => {
                            onDeleteConfirm()
                        }}
                        confirmText="Delete"
                        denyAction={() => {
                            setShowDeleteModal(false)
                        }}
                        denyText="Cancel"
                        // isSubmit={true}
                    >
                        <>
                            Deleting this join will reset all report
                            configurations associated with the To Source.
                            <br />
                            Are you sure you want to continue?
                        </>
                    </ConfirmationModal>
                </div>
            </div>
        </CollapsibleContainer>
    )
}

export default Joins
